export const agreementsVersions = {
    agreementVersion: "v3",
    kvkkVersion: "v1",
    kvkkInfoVersion: "v1",
    ipazVersion: "v1"
}